import React, { useState } from 'react';
import { motion } from 'framer-motion';
import styles from './ContactPage.module.css';
import { useLang } from '../../context/LanguageContext';

const fadeUp = {
  hidden: { opacity: 0, y: 22 },
  visible: (i = 0) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.55, delay: i * 0.09, ease: [0.25, 0.46, 0.45, 0.94] },
  }),
};

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', type: '', description: '' });
  const [sent, setSent] = useState(false);
  const { t } = useLang();
  const c = t.contact;

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <div className={styles.page}>
      <div className={styles.gridBg} />

      {/* Hero */}
      <section className={styles.hero}>
        <div className={styles.container}>
          <motion.p className={styles.eyebrow} variants={fadeUp} initial="hidden" animate="visible" custom={0}>
            {c.eyebrow}
          </motion.p>
          <motion.h1 className={styles.title} variants={fadeUp} initial="hidden" animate="visible" custom={1}>
            {c.title}
          </motion.h1>
          <motion.p className={styles.sub} variants={fadeUp} initial="hidden" animate="visible" custom={2}>
            {c.sub}
          </motion.p>
        </div>
      </section>

      {/* Content */}
      <section className={styles.content}>
        <div className={styles.container}>
          <div className={styles.layout}>

            {/* Aside */}
            <motion.aside className={styles.aside} variants={fadeUp} initial="hidden" animate="visible" custom={2}>
              <div className={styles.asideBlock}>
                <p className={styles.asideLabel}>{c.emailLabel2}</p>
                <a href="mailto:contact@axisdevagency.com" className={styles.asideEmail}>
                  contact@axisdevagency.com
                </a>
              </div>
              <div className={styles.asideSep} />
              <p className={styles.asideHint}>{c.callHint}</p>
            </motion.aside>

            {/* Form */}
            <motion.div className={styles.formWrap} variants={fadeUp} initial="hidden" animate="visible" custom={3}>
              {sent ? (
                <div className={styles.success}>
                  <div className={styles.successIcon}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <h3 className={styles.successTitle}>{c.successTitle}</h3>
                  <p className={styles.successSub}>{c.successSub}</p>
                </div>
              ) : (
                <form className={styles.form} onSubmit={handleSubmit} noValidate>
                  <div className={styles.row}>
                    <div className={styles.field}>
                      <label className={styles.label} htmlFor="name">{c.nameLabel}</label>
                      <input
                        id="name" name="name" type="text"
                        value={form.name} onChange={handleChange}
                        required className={styles.input}
                        placeholder={c.namePh}
                      />
                    </div>
                    <div className={styles.field}>
                      <label className={styles.label} htmlFor="email">{c.emailLabel}</label>
                      <input
                        id="email" name="email" type="email"
                        value={form.email} onChange={handleChange}
                        required className={styles.input}
                        placeholder={c.emailPh}
                      />
                    </div>
                  </div>

                  <div className={styles.field}>
                    <label className={styles.label} htmlFor="type">{c.typeLabel}</label>
                    <select
                      id="type" name="type"
                      value={form.type} onChange={handleChange}
                      className={styles.input}
                    >
                      <option value="">{c.typeDefault}</option>
                      {c.projectTypes.map(pt => <option key={pt} value={pt}>{pt}</option>)}
                    </select>
                  </div>

                  <div className={styles.field}>
                    <label className={styles.label} htmlFor="description">{c.descLabel}</label>
                    <textarea
                      id="description" name="description"
                      value={form.description} onChange={handleChange}
                      required className={styles.textarea}
                      rows={5}
                      placeholder={c.descPh}
                    />
                  </div>

                  <button type="submit" className={styles.submit}>
                    {c.submitBtn}
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                  </button>
                </form>
              )}
            </motion.div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
